import axios, { AxiosError } from 'axios';
import { EHttpStatusCode } from './type';
// @ts-ignore
import { auth } from '@my-account/tools';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(async config => {
    try {
        const token = await auth.getToken();
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    } catch (e) {
        return Promise.reject(e);
    }
});

axiosInstance.interceptors.response.use(
    response => response,
    (error: AxiosError) => {
        if (EHttpStatusCode.UNAUTHORIZED === error.response?.status) {
            auth.logout();
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
